import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import { FilterHeader } from "@shared/table/headers/FilterHeader";
import { ColumnFiltersState } from "@tanstack/react-table";

const useOptions = () => {
    const { t } = useTranslation(["pages"]);
    return [
        { key: "Public", label: t("pages:downloadsPage.table.visibility.public") },
        { key: "Private", label: t("pages:downloadsPage.table.visibility.private") },
    ];
};

type Props = {
    columnFilters: ColumnFiltersState;
    setColumnFilters: Dispatch<SetStateAction<ColumnFiltersState>>;
};

export const VisibilityHeader = ({ columnFilters, setColumnFilters }: Props) => {
    const { t } = useTranslation(["modals"]);
    const options = useOptions();
    const current = (columnFilters.find((f) => f.id === "visibility")?.value as string[] | undefined) ?? [];

    return (
        <FilterHeader
            title={t("modals:filterDialog.variants.visibility")}
            sortDisabled
            options={options}
            initialValues={Object.fromEntries(options.map((o) => [o.key, current.includes(o.key)]))}
            onSubmit={(values) => {
                const value = Object.keys(values).filter((k) => values[k]);
                setColumnFilters((prev) => {
                    const rest = prev.filter((f) => f.id !== "visibility");
                    return value.length ? [{ id: "visibility", value }, ...rest] : rest;
                });
            }}
        />
    );
};
